import { API_ROOT } from '../../config/config'
import { doDelete, doDownload, doGet, doPostFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getInstallmentIncome = (projectCode, period, id) => {
  const url = `${API_ROOT}/v1/accounting/installment/income/${projectCode}/${period}?id=${id}`
  return doGet(url)
}

export const saveInstallmentIncome = (request, projectCode, period) => {
  const url = `${API_ROOT}/v1/accounting/installment/income/${projectCode}/${period}/save`
  return doPostFiles(url, request)
}

export const deleteInstallmentIncome = (id) => {
  const url = `${API_ROOT}/v1/accounting/installment/income/${id}`
  return doDelete(url)
}

export const downloadInstallmentIncomeAttacthment = (fileId) => {
  const url = `${API_ROOT}/v1/accounting/installment/income/attachments/download/${fileId}`
  return doDownload(url)
}

export const downloadInstallmentIncomeDetailAttacthment = (incomeDetailId) => {
  const url = `${API_ROOT}/v1/accounting/installment/income/detail/attachments/download/${incomeDetailId}`
  return doDownload(url)
}

//รายชื่อผู้ให้เงิน
export const getReceivedFrom = (projectCode, nameOrId, isSubproject) => {
  const url = `${API_ROOT}/v1/accounting/received-from/${projectCode}?nameOrId=${
    nameOrId || ''
  }&isSubproject=${isSubproject || ''}`
  return doGet(url)
}

export const getReceivedFromById = (id) => {
  const url = `${API_ROOT}/v1/accounting/received-from/by-id/${id}`
  return doGet(url)
}

export const downloadTaxWithholdingFile = (accountingExpensesDetailId) => {
  const url = `${API_ROOT}/files/${accountingExpensesDetailId}/tax/withholding/form`
  return doDownload(url)
}

export const downloadRecieptVoucherFile = (accountingIncomeId) => {
  const url = `${API_ROOT}/files/${accountingIncomeId}/reciept/voucher/form`
  return doDownload(url)
}
